import { render, staticRenderFns } from "./PrStatusBadge.vue?vue&type=template&id=8ad144ea&scoped=true"
import script from "./PrStatusBadge.vue?vue&type=script&lang=js"
export * from "./PrStatusBadge.vue?vue&type=script&lang=js"
import style0 from "./PrStatusBadge.vue?vue&type=style&index=0&id=8ad144ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ad144ea",
  null
  
)

export default component.exports